// neo_cogym — 결제 클라이언트 (W9)
import { apiFetch } from "./client";

export interface CheckoutResult {
  orderId: string;
  provider: string;
  mode: string;
  payParams: { merchantUid: string; payMethod: string };
}

export function checkout(productId: string, quantity = 1, currency = "KRW"): Promise<CheckoutResult> {
  return apiFetch("/api/payment/checkout", {
    method: "POST",
    body: JSON.stringify({ productId, quantity, currency }),
  });
}

/** 실 PG 연동 전 테스트 결제완료(개발). 실 운영은 포트원 SDK→웹훅. */
export function testComplete(orderId: string): Promise<{ ok: boolean }> {
  return apiFetch("/api/payment/test-complete", {
    method: "POST",
    body: JSON.stringify({ orderId }),
  });
}
